import { useQuery } from "@tanstack/react-query";
import { getClient } from "../http/userApi";
import { getClientsArrQueryKey } from "@/utils/queryKeys";

export type ClientWithToken = {
  token: string;
  data: Awaited<ReturnType<typeof getClient>>["data"];
};

export const useGetClientsArrQuery = (userTokens?: Array<string>) => {
  // Create a stable key from sorted unique tokens
  const uniqueTokens = userTokens ? [...new Set(userTokens)].sort() : [];

  return useQuery({
    queryKey: [...getClientsArrQueryKey(), uniqueTokens],
    queryFn: async (): Promise<ClientWithToken[]> => {
      if (uniqueTokens.length === 0) return [];
      const responses = await Promise.all(
        uniqueTokens.map(async (token) => {
          const response = await getClient(token);
          return { token, data: response.data };
        })
      );
      return responses;
    },
    enabled: uniqueTokens.length > 0,
  });
};
